import { Navigate, type RouteObject } from 'react-router-dom';
import WorkOrdersPage from './pages/WorkOrdersPage';
import WorkOrderPage from './pages/WorkOrderPage';
import NewWorkOrderPage from './pages/NewWorkOrderPage';
import NewWOTemplatesPage from '../wo-template/pages/NewWOTemplatesPage';
import WOTemplatePage from '../wo-template/pages/WOTemplatePage';
import TechnicianRedirect from './components/TechnicianRedirect';

const routes: RouteObject[] = [
  {
    index: true,
    element: <TechnicianRedirect />,
  },
  {
    path: 'list',
    children: [
      {
        index: true,
        element: <WorkOrdersPage tab="list" />,
      },
    ],
  },
  {
    path: 'fsm-list',
    children: [
      {
        index: true,
        element: <WorkOrdersPage tab="fsm-list" />,
      },
    ],
  },
  {
    path: 'templates',
    children: [
      {
        index: true,
        element: <WorkOrdersPage tab="templates" />,
      },
      {
        path: 'new',
        element: <NewWOTemplatesPage />,
      },
      {
        path: ':id',
        children: [
          {
            index: true,
            element: <Navigate to="details" replace />,
          },
          {
            path: ':tab',
            element: <WOTemplatePage />,
          },
        ],
      },
    ],
  },
  {
    path: 'new',
    element: <NewWorkOrderPage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: 'expenses',
        element: <WorkOrderPage tab="expenses" />,
      },
      {
        path: 'details',
        element: <WorkOrderPage tab="details" />,
      },
      {
        path: ':tab',
        element: <WorkOrderPage />,
      },
    ],
  },
];

export default routes;
